import { GenericAbortSignal } from "axios";
import { AutoCompleteHierarchicalModel, AutoCompleteHierarchicalSuggestions, UnitAutoCompleteHierarchicalModel } from "components/MprcAutoCompleteHierarchical/AutoCompleteHierarchicalModel";
import { GroupType } from "generated/CoreApi_v1";
import { isCanceledError, useCoreApi } from "providers/CoreApiProvider";
import React from "react";
import { IUnitAutoCompleteProps, UnitAutoCompleteHierarchicalComponent } from "views/foundation/unit/components/UnitAutoCompleteHierarchicalComponent";

////////////////////////////////////////////////////////////////////////////

interface IProps extends IUnitAutoCompleteProps {
    groupType: GroupType;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete hierarquico de unidades administrativa
 * @param props
 */
export const GroupUnitAutoCompleteHierarchical: React.FC<IProps> = (props) => {

    const { required = false, disabled = false, selectedMode = "free", showDescendantOption, groupType, onError } = props;
    const api = useCoreApi();

    /// Carrega a lista de sugestões
    const getSuggestions = (parentId: string | null, trySelectionHistory: boolean, searchText: string, pageNumber: number, pageSize: number, signal: GenericAbortSignal | undefined): Promise<AutoCompleteHierarchicalSuggestions<AutoCompleteHierarchicalModel>> => {
        searchText = searchText.toLowerCase();

        return new Promise<AutoCompleteHierarchicalSuggestions<UnitAutoCompleteHierarchicalModel>>((resolve) => {
            api.v1.suggestions.groupUnitSuggestions({
                parentId: parentId,
                trySelectionHistory: trySelectionHistory,
                allowIncludeDescendants: showDescendantOption ?? false,
                ignoreAllowAssociates: selectedMode == "free",
                searchText: searchText,
                showRoot: false,
                pageNumber: pageNumber,
                pageSize: pageSize,
                groupType: groupType
            }, { signal })
                .then(result => {
                    resolve({
                        items: result.data.items as UnitAutoCompleteHierarchicalModel[],
                        totalRows: result.data.totalRows
                    });
                })
                .catch(e => {
                    if (!isCanceledError(e)) {
                        resolve({ items: [], totalRows: 0 });
                        onError(e);
                    }
                });
        });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <UnitAutoCompleteHierarchicalComponent
            {...props}
            required={required}
            disabled={disabled}
            showUnitTypeName={true}
            onGetSuggestions={getSuggestions}
        />
    );
};
